// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SceneMixer = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M11.26 29.466a2.759 2.759 0 0 1 0-5.516h17.366c1.136-3.158 4.13-5.434 7.681-5.434a8.195 8.195 0 0 1 8.192 8.192 8.195 8.195 0 0 1-8.192 8.193c-3.552 0-6.545-2.276-7.681-5.435H11.259Zm40.594 0a2.759 2.759 0 0 1 0-5.516H84.74a2.759 2.759 0 0 1 0 5.516H51.854ZM84.742 45.24a2.759 2.759 0 0 1 0 5.516H68.236a2.759 2.759 0 0 1 0-5.516h16.506Zm0 21.292a2.759 2.759 0 0 1 0 5.516H59.694a2.759 2.759 0 0 1 0-5.516h25.048ZM36.307 61.1a8.195 8.195 0 0 1 8.192 8.193 8.195 8.195 0 0 1-8.192 8.192c-3.552 0-6.545-2.276-7.681-5.434H11.259a2.759 2.759 0 0 1 0-5.516h17.367c1.136-3.162 4.13-5.435 7.681-5.435ZM60.883 47.93a8.195 8.195 0 0 1-8.193 8.193c-3.526 0-6.504-2.24-7.659-5.365H11.258a2.759 2.759 0 0 1 0-5.516h33.73c1.117-3.199 4.128-5.504 7.702-5.504a8.195 8.195 0 0 1 8.193 8.192Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default SceneMixer;
